<app-modal-template
  [secondaryButtonVisible]="false"
  [primaryButtonText]="'LOGOUT' | translate"
  (successEvent)="logout()">
  <div class="account-closed-modal">
    <h2 class="account-closed-modal__title">{{ 'ACCOUNT_CLOSED_MODAL.TITLE' | translate }}</h2>
    <p class="account-closed-modal__message">{{ 'ACCOUNT_CLOSED_MODAL.MESSAGE' | translate }}</p>
    <p class="account-closed-modal__message mt-4">{{ 'ACCOUNT_CLOSED_MODAL.MESSAGE_2' | translate }}</p>
  </div>
</app-modal-template>
